import axios, { AxiosResponse } from 'axios'
import {
  IPortalUserFilter,
  IPortalUserResponseModel,
} from '../models/PortalUsers'

export const getPortalUsers = (
  filter: IPortalUserFilter
): Promise<AxiosResponse<IPortalUserResponseModel>> =>
  axios.post(`client/clients/${filter.clientId}/portalusers`, filter, {
    cancelToken: filter.source?.token,
    headers: {
      'x-api-version': '1.0',
    },
  })

export const getPortalUserSummary = (
  clientId: string
): Promise<AxiosResponse<IPortalUserResponseModel>> =>
  axios.get(`client/clients/${clientId}/portalusers/summary`, {
    headers: {
      'x-api-version': '1.0',
    },
  })
